.ba{justify-content:flex-end;}